import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { useAuth } from '../../auth/AuthProvider';

export function Header() {
    const { user, signOut } = useAuth();

    return (
        <header className="fixed top-0 left-0 right-0 z-50 px-4 py-3 bg-transparent pointer-events-none">
            <div className="max-w-7xl mx-auto flex items-center justify-between pointer-events-auto">
                {/* Logo */}
                <Link to="/" className="hover:scale-105 transition-transform duration-200">
                    <img
                        src="/img/title_wide.png"
                        alt="INTPCAT.NET"
                        className="h-12 md:h-16 object-contain drop-shadow-md"
                    />
                </Link>

                {/* Nav Links - Desktop */}
                <nav className="hidden md:flex items-center gap-8 font-hand text-xl font-bold tracking-wide">
                    <Link to="/explore" className="text-zinc-800 hover:text-primary transition-colors">EXPLORE</Link>
                    <Link to="/creators" className="text-zinc-800 hover:text-primary transition-colors">CREATORS</Link>
                    <Link to="/shop" className="text-zinc-800 hover:text-primary transition-colors">SHOP</Link>
                </nav>

                {/* Auth Actions */}
                <div className="flex gap-3">
                    {user ? (
                        <Button
                            variant="ghost"
                            className="bg-white border-2 border-border font-bold shadow-[4px_4px_0_0_#000] hover:translate-y-1 hover:shadow-none transition-all"
                            onClick={() => signOut()}
                        >
                            Log Out
                        </Button>
                    ) : (
                        <>
                            <Link to="/login">
                                <Button variant="ghost" className="font-bold border-2 border-transparent hover:border-border">
                                    Login
                                </Button>
                            </Link>
                            <Link to="/register">
                                <Button className="font-bold bg-primary border-2 border-border shadow-[4px_4px_0_0_#000] text-zinc-900 rounded-full px-6 hover:translate-y-1 hover:shadow-none transition-all">
                                    Join Zine
                                </Button>
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
